function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M10.559 25.102L1.975 27.85l.85-11.652 8.184-2.748-.45 11.652zM30.025 25.102l-8.667 2.331-.417-11.235 8.184-2.748.9 11.652zM18.417 15.578c-.718.644-1.3 1.09-1.466 1.22l-.6.456-.6-.456a23.815 23.815 0 01-3.5-3.292l-.365-.122-.45 11.651 9.051 2.332-.417-11.235z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16.348 4.15a5.134 5.134 0 00-5.134 5.134c0 2.835 5.134 6.716 5.134 6.716s5.133-3.881 5.133-6.716a5.133 5.133 0 00-5.133-5.134zm-.155 7.07a2.568 2.568 0 112.568-2.567 2.567 2.567 0 01-2.568 2.567z"
})));

var SvgServiceCentermin = function SvgServiceCentermin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServiceCentermin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ServiceCenter.min.e2690eaa.svg";
export { ForwardRef as ReactComponent };